'use strict';

function InventoryManagementDataService(dataRetriever, dataTransformers) {
  function getData(selectedFlights) {
    return dataRetriever.getInventoryManagementData(selectedFlights).then(dataTransformers.transform);
  }
  return {
    getData: getData
  };
}
InventoryManagementDataService.$inject = ['FlightManagementDataRetrieverService', 'InventoryManagementDataTransformService'];
module.exports = InventoryManagementDataService;